import React from "react";
import {useProjectId} from "../ProjectName";
import {QuoteSwitcher} from "../../quote/pricing/QuoteSwitcher";

export function GlazingSwitcher() {
    const projectId = useProjectId();

    return (
        <QuoteSwitcher
            title="Glazing"
            url={`/project/${projectId}/shop-drawing/glazing`}
            quoteTitle="Quote Glazing"
            quoteURL={`/project/${projectId}/quote/-1/glazing`}
        />
    )
}
